import React, { useState } from "react";
import { Form, Input, Select, Button, Row, Col, Spin, message } from "antd";
import axios from "axios";
import Turnstile from "react-turnstile";

const { TextArea } = Input;
const { Option } = Select;

const KEY_CAPTCHA = process.env.REACT_APP_CLAVE_RECAPTCHA;

export const Contacto = ({ tituloColor, botonColor }) => {
  const [form] = Form.useForm();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (!captchaToken) {
      message.error("Por favor, completá el captcha.");
      return;
    }

    // Trim solo al enviar
    const clean = (v) => (typeof v === "string" ? v.trim() : v);
    const payload = {
      nombre: clean(values.nombre),
      email: clean(values.email),
      motivo: clean(values.motivo),
      asunto: clean(values.asunto),
      mensaje: clean(values.mensaje),
      token: captchaToken,
    };

    setLoading(true);
    try {
      await axios.post(process.env.REACT_APP_URL_API_MAILS, payload);
      message.success("¡Correo enviado exitosamente!");
      form.resetFields();
      setCaptchaToken(null);
    } catch (error) {
      console.error("Error al enviar el correo:", error);
      message.error("Hubo un error al enviar el correo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contacto"
      className="contacto"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "3rem 1rem",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" />
        </div>
      )}

      <div style={{ filter: loading ? "blur(3px)" : "none", width: "100%", maxWidth: "1100px" }}>
        <h1
          style={{ color: tituloColor, textAlign: "center", marginBottom: "2rem" }}
          className="titulos-degrade"
        >
          Contactate con <b>nosotros</b>
        </h1>

        <Row gutter={[40, 32]} align="top">
          {/* Columna izquierda: Formulario */}
          <Col xs={24} md={14}>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              validateTrigger={["onBlur", "onSubmit"]}
            >
              <Row gutter={[8, 0]}>
                <Col xs={24} md={8}>
                  <Form.Item
                    label="Nombre"
                    name="nombre"
                    rules={[
                      { required: true, message: "El nombre es obligatorio" },
                      { min: 2, message: "El nombre debe tener al menos 2 caracteres" },
                    ]}
                  >
                    <Input placeholder="Tu nombre" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "El email es obligatorio" },
                      { type: "email", message: "Ingresá un email válido" },
                    ]}
                  >
                    <Input placeholder="tu@email.com" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                  <Form.Item
                    label="Motivo"
                    name="motivo"
                    rules={[{ required: true, message: "Seleccioná un motivo" }]}
                  >
                    <Select placeholder="Seleccioná un motivo" allowClear>
                      <Option value="Consulta general">Consulta general</Option>
                      <Option value="Proyecto Desarrollo">Proyecto Desarrollo</Option>
                      <Option value="Proyecto Seguridad">Proyecto Seguridad</Option>
                      <Option value="Soporte técnico">Soporte técnico</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item
                    label="Asunto"
                    name="asunto"
                    rules={[
                      { required: true, message: "El asunto es obligatorio" },
                      { min: 4, message: "El asunto debe tener al menos 4 caracteres" },
                    ]}
                  >
                    <Input placeholder="¿Sobre qué querés hablar?" />
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item
                    label="Mensaje"
                    name="mensaje"
                    rules={[
                      { required: true, message: "El mensaje es obligatorio" },
                      { min: 10, message: "El mensaje debe tener al menos 10 caracteres" },
                    ]}
                  >
                    <TextArea rows={4} placeholder="Contanos en detalle..." />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} style={{ textAlign: "center" }}>
                  <Turnstile
                    sitekey={KEY_CAPTCHA}
                    onVerify={(token) => setCaptchaToken(token)}
                    options={{ theme: "light" }}
                  />
                </Col>

                <Col xs={24} md={12} style={{ textAlign: "right", marginTop: "2em" }}>
                  <Button
                    htmlType="submit"
                    loading={loading}
                    disabled={!captchaToken || loading}
                    style={{
                      background: `linear-gradient(45deg, ${botonColor[0]}, ${botonColor[1]})`,
                      borderColor: botonColor,
                      color: "#fff",
                      borderRadius: "1em",
                      fontSize: "1.5em",
                      padding: "1em",
                    }}
                  >
                    Enviar
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>

          {/* Columna derecha: Agendar reunión */}
          <Col xs={24} md={10}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                padding: "2rem",
                borderRadius: "12px",
                border: "1px solid rgba(23, 94, 106, 0.25)",
                background: "rgba(23, 94, 106, 0.05)",
                textAlign: "center",
                gap: "1.2rem",
              }}
            >
              <span style={{ fontSize: "3.5rem" }}>📅</span>
              <h2 style={{ color: tituloColor, margin: 0, fontSize: "1.4rem", fontWeight: 700 }}>
                ¿Preferís hablar directamente?
              </h2>
              <p style={{ color: tituloColor, margin: 0, opacity: 0.7, fontSize: "0.95rem" }}>
                Agendá una reunión con nuestro equipo en el horario que mejor te convenga.
              </p>
              <a
                href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0804XeymdtwoovgXitOCWaT7fUL4Zmg_DThBJVjz8uLbdXqlVBT-4xmvsDHAsaPffWEuu6Epvx?gv=true"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: '#175E6A',
                  color: 'white',
                  padding: '14px 32px',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  textDecoration: 'none',
                  display: 'inline-block',
                  transition: 'opacity 0.2s',
                }}
                onMouseOver={e => e.currentTarget.style.opacity = '0.85'}
                onMouseOut={e => e.currentTarget.style.opacity = '1'}
              >
                Reservar una cita
              </a>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Contacto;
